module.exports = __webpack_public_path__ + "static/img/IOHomepage.32dfacd.png";